module.exports = __webpack_public_path__ + "img/home-delivery_small.9fdfc3c3.jpg";